import { createBrowserRouter, RouterProvider, useRouteError, Link } from 'react-router';
import { Boot } from './Boot';
import { AppLayout } from './AppLayout';
import { ThemeProvider } from './providers';
import { ConfirmProvider, ToastProvider } from '@/ui/overlay';
import { Card, Notice } from '@/ui/core';
import { routes } from './routes';

function RouteError() {
  const err = useRouteError() as { status?: number; message?: string; statusText?: string };
  const notFound = err?.status === 404;
  return (
    <div className="mx-auto max-w-lg p-6">
      <Card>
        <Notice tone={notFound ? 'info' : 'danger'} title={notFound ? 'Page not found' : 'Something went wrong on this screen'}>
          {notFound ? 'That address does not exist in this app.' : (err?.message ?? err?.statusText ?? 'Unknown error')}
          <p className="mt-2">Your saved entries are not affected.</p>
        </Notice>
        <Link to="/" className="mt-4 inline-block font-semibold text-accent underline">
          Back to the home screen
        </Link>
      </Card>
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteError />,
    children: routes,
  },
]);

export function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <ConfirmProvider>
          <Boot>
            <RouterProvider router={router} />
          </Boot>
        </ConfirmProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
